import React, { useState, useEffect } from 'react'
import {
  ticketExchangeSearch,
  ticketExchangeSeatMap,
  ticketExchangeGetEvents,
  ticketExchangeGetTickets,
} from '../../utilities/api'

import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'

import Search from './Search'
import ResultsTable from './ResultsTable'
import ExchangeModal from './ExchangeModal'
import { Spinner } from '../LoadingContainer/Spinner'
import ExchangeTable from './ExhangeTable'

export default function TicketExchangeWrapper({ organization }) {
  const [results, setResults] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedTickets, setSelectedTickets] = useState([])
  const [show, setShow] = useState(false)
  const [selectedEvent, setEvent] = useState()
  const [toEvent, setToEvent] = useState()
  const [query, setQuery] = useState('')
  const [orgEvents, setOrgEvents] = useState([])
  const [exchanges, setExchanges] = useState([])
  const [selectedAssignedTickets, setSelectedAssignSeats] = useState()

  const getTickets = () => {
    setIsLoading(true)
    ticketExchangeGetTickets(organization.uuid)
      .then((res) => {
        setExchanges(res.data)
        setIsLoading(false)
      })
      .catch((err) => {
        console.error(err)
        setIsLoading(false)
      })
  }

  const getEvents = () => {
    ticketExchangeGetEvents(organization.uuid)
      .then((res) => {
        setOrgEvents(res.data)
      })
      .catch((err) => console.error(err))
  }

  const handleSearch = () => {
    // Handle the query change, e.g., update state or make API calls
    const data = {}
    data.term = query
    data.organizationUUID = organization.uuid
    setIsLoading(true)
    ticketExchangeSearch(data)
      .then((response) => {
        setResults(response.data)
        setIsLoading(false)
      })
      .catch((error) => {
        console.error('Search error:', error)
        setIsLoading(false)
      })
  }

  const getCheckboxValues = () => {
    const checkboxes = document.getElementsByClassName('checkbox')
    let selected = []
    for (let checkbox of checkboxes) {
      const input = checkbox.querySelector('input')
      if (input.checked) {
        selected.push({
          eventUUID: input.dataset.event,
          eventName: input.dataset.eventname,
          eventDate: input.dataset.eventdate,
          id: input.dataset.ticketId,
          ticketUUID: input.dataset.ticket,
          sectionNumber: input.dataset.sectionnumber,
          rowNumber: input.dataset.rownumber,
          seatNumber: input.dataset.seatnumber,
          generalAdmission: input.dataset.generaladmission === 'true',
          orderId: input.dataset.orderId,
          userEmail: input.dataset.userEmail,
        })
      }
    }
    if (selected.length === 0) return

    setSelectedTickets(selected)
    setShow(true)
  }

  // save regular seated seats,,,
  const selectRegularSeats = (seatId, seatIdArray) => {
    if (seatId) {
      console.log('seatId: ', seatId)
    } else if (seatIdArray) {
      console.log('seatIdArray: ', seatIdArray)
    }
  }

  const handleSectionSelect = (e, section) => {
    const stage = e.target.getStage()
    const pointerPos = stage.getPointerPosition() // Relative to stage
    const stageRect = stage.container().getBoundingClientRect() // Relative to window
    const tooltipX = stageRect.left + pointerPos.x
    const tooltipY = stageRect.top + pointerPos.y
    // showTooltip(false, section.sectionId, tooltipX, tooltipY);
  }

  const getSeatMap = () => {
    ticketExchangeSeatMap({ eventUUID: selectedEvent })
      .then((res) => {
        setToEvent(res.data)
      })
      .catch((err) => console.error(err))
  }

  useEffect(() => {
    getTickets()
    getEvents()
    if (selectedEvent) getSeatMap()
  }, [selectedEvent])

  function Message({ children }) {
    return (
      <Card
        body
        style={{
          textAlign: 'center',
        }}
      >
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className=" mb-4"
        >
          <rect
            width="80"
            height="80"
            rx="40"
            fill="#3EA9F7"
            fillOpacity="0.12"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 26C22 21.5817 25.5817 18 30 18H46.6863C48.808 18 50.8429 18.8429 52.3431 20.3431L55.6569 23.6569C57.1571 25.1571 58 27.192 58 29.3137V54C58 58.4183 54.4183 62 50 62H30C25.5817 62 22 58.4183 22 54V26ZM54 32V54C54 56.2091 52.2091 58 50 58H30C27.7909 58 26 56.2091 26 54V26C26 23.7909 27.7909 22 30 22H44V26C44 29.3137 46.6863 32 50 32H54ZM53.7781 28C53.5817 27.4352 53.2593 26.9162 52.8284 26.4853L49.5147 23.1716C49.0839 22.7407 48.5648 22.4183 48 22.2219V26C48 27.1046 48.8954 28 50 28H53.7781Z"
            fill="#3E8BF7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.0639 46.8924C40.8729 47.5961 39.4836 48 38 48C33.5817 48 30 44.4183 30 40C30 35.5817 33.5817 32 38 32C42.4183 32 46 35.5817 46 40C46 41.4836 45.5961 42.8729 44.8924 44.0639L49.4144 48.5859C50.1954 49.367 50.1954 50.6333 49.4144 51.4144C48.6333 52.1954 47.367 52.1954 46.5859 51.4144L42.0639 46.8924ZM42 40C42 42.2091 40.2091 44 38 44C35.7909 44 34 42.2091 34 40C34 37.7909 35.7909 36 38 36C40.2091 36 42 37.7909 42 40Z"
            fill="#3E8BF7"
          />
        </svg>
        {children}
      </Card>
    )
  }

  return (
    <>
      <section className="mb-4">
        <header className="section-header mt-4">
          <div className="section-header">
            <div className="section-heading">
              <h1>Ticket Exchange</h1>
            </div>
            <p className="section-header-desc">
              Transfer unscanned tickets to future events, ensuring that
              everyone can attend the event they want.
            </p>
          </div>
        </header>
      </section>
      <Search setQuery={setQuery} handleSearch={handleSearch} />

      <div className="mt-3">
        {isLoading ? (
          <div className="flex justify-content-center align-items-center">
            <Spinner variant="dark" size="lg" />
          </div>
        ) : (
          <>
            {results ? (
              <>
                {results?.length > 0 ? (
                  <div
                    className="mt-2"
                    style={{ height: '60vh', overflowY: 'scroll' }}
                  >
                    <ResultsTable
                      tickets={results.tickets}
                      events={results.events}
                      isLoading={isLoading}
                      results={results}
                    />
                  </div>
                ) : (
                  <Message>
                    <h4
                      style={{
                        fontSize: 16,
                        color: '#000000',
                        marginBottom: 12,
                      }}
                    >
                      No results for your search criteria
                    </h4>
                    <span style={{ fontSize: 14, color: '#353945' }}>
                      Make sure the information submitted is correct and try
                      again.
                    </span>
                  </Message>
                )}
              </>
            ) : exchanges.length > 0 ? (
              <>
                <ExchangeTable data={exchanges} />
              </>
            ) : (
              <Message>
                <h4
                  style={{ fontSize: 16, color: '#000000', marginBottom: 12 }}
                >
                  Transfer a user's seats to another game
                </h4>
                <span style={{ fontSize: 14, color: '#353945' }}>
                  Search by organization name, buyer’s name, or email address to
                  locate the user and start the seat transfer process.
                </span>
              </Message>
            )}
          </>
        )}
        <Button className="mt-3" onClick={getCheckboxValues}>
          Exchange Tickets
        </Button>
      </div>

      <ExchangeModal
        show={show}
        setShow={setShow}
        selectedTickets={selectedTickets}
        events={orgEvents}
        setEvent={setEvent}
        selectedEvent={selectedEvent}
        selectRegularSeats={selectRegularSeats}
        handleSectionSelect={handleSectionSelect}
        toEvent={toEvent}
      />
    </>
  )
}
